import { render, staticRenderFns } from "./MypageLanguageSettingPane.vue?vue&type=template&id=32c6cfe2&scoped=true"
import script from "./MypageLanguageSettingPane.vue?vue&type=script&lang=ts"
export * from "./MypageLanguageSettingPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageLanguageSettingPane.vue?vue&type=style&index=0&id=32c6cfe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c6cfe2",
  null
  
)

export default component.exports